import React from 'react';
import { Box, Typography, TextField, InputAdornment, IconButton , Button } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useNavigate } from "react-router";
import { useSelector } from 'react-redux';

const MiniHeader = () => {
  const navigate = useNavigate();
  const { isAuthenticated, currentUser } = useSelector((state) => state.auth);
  
  // Get user's display name
  const getUserDisplayName = () => {
    if (!currentUser) return '';
    return currentUser.name || currentUser.username || currentUser.email || '';
  };

  return (
   <>
      {/* Mini Header with Gradient */}
      <Box
        sx={{
        //   width: '100%',
          background: 'linear-gradient(to right, #007A6B, #0C5A89)',
          color: 'white',
          display: 'flex',
          justifyContent: 'flex-end',
          alignItems: 'center',
          px: 2,
          py: 1,
          fontSize: 14,
          paddingRight:"34px",
          gap: 2
        }}
        
        className="miniHeaderBar"
      >
        {/* <Typography sx={{ mr: 2, cursor: 'pointer' }} className='contactUsHeading'>CONTACT US</Typography> 
        <span className='lineSpace'> |
        &nbsp; &nbsp; &nbsp; </span> 
        <Typography sx={{ mr: 2, cursor: 'pointer' }}>ENQUIRY</Typography> */}

        {/* Search Box */}
        {/* <TextField
          variant="outlined"
          size="small"
          placeholder="Search"
          sx={{
            backgroundColor: 'white',
            borderRadius: 1,
            input: { padding: '4px 8px' },
            width: { xs: '109px', sm: '160px' },
          }}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton size="small">
                  <SearchIcon />
                </IconButton>
              </InputAdornment>
            ),
          }}
        /> */}

        {/* Show user name if logged in, otherwise show login button */}
        {isAuthenticated && currentUser ? (
          <>
            <Typography 
              sx={{ 
                fontSize: 14,
                fontWeight: 500,
                display: { xs: 'none', sm: 'block' }
              }}
            >
              Welcome, {getUserDisplayName()}
            </Typography>
            <Button 
              className="LoginBtn" 
              onClick={() => navigate('/dashboard')}
              sx={{ minWidth: 'auto' }}
            >
              Dashboard
            </Button>
          </>
        ) : (
          <Button className="LoginBtn" onClick={() => navigate('/login')}>Login</Button>
        )}
      </Box>

     </>
  );
};

export default MiniHeader;
